import React from 'react';
import Particles from 'react-particles-js';

export default class MasterElements extends React.PureComponent {
    static propTypes = {};
    render() {
        const canvasParams = {
            particles: {
                number: {
                    value: 25,
                    density: {
                        enable: true,
                        value_area: 500
                    }
                },
                color: {
                    value: ['#6aecfc']
                },
                shape: {
                    type: 'circle'
                },
                opacity: {
                    value: 0.4,
                    random: true,
                    anim: {
                        enable: false,
                        speed: 1,
                        opacity_min: 0.3,
                        sync: false
                    }
                },
                size: {
                    value: 10,
                    random: true,
                    anim: {
                        enable: true,
                        speed: 2,
                        size_min: 50,
                        sync: false
                    }
                },
                line_linked: {
                    enable: false
                },
                move: {
                    enable: true,
                    speed: 3,
                    direction: 'top',
                    random: true,
                    straight: false,
                    out_mode: 'out',
                    bounce: false,
                    attract: {
                        enable: true,
                        rotateX: 1200,
                        rotateY: 1200
                    }
                }
            },
            retina_detect: true
        };
        return (
            <div className="master-elements">
                <div className="background" />
                <Particles
                    width="100%"
                    height="100%"
                    className="canvasContainer"
                    canvasClassName="elementsCanvas"
                    params={canvasParams} />
                <div className="waterSwirl" />
                <div className="waterDragon" />
                <div className="content">
                    <h1>Master The Elements</h1>
                    <p>Tsunamis, earthquakes, and firestorms are yours to command.</p>
                </div>
            </div>
        );
    }
}

